import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetodivegarcab() {



    const cardData = {

keyword: "Pune to Diveagar Cabs",

headingDescription:
    "Rising Cab Service offers safe, comfortable, and reliable Pune to Diveagar Cabs for families, couples, and beach travelers. We provide well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury vehicles with experienced chauffeurs for a smooth coastal journey from Pune to Konkan. Our service includes doorstep pickup, flexible one-way and round-trip options, 24/7 support, and transparent pricing, ensuring a relaxing and scenic travel experience to the peaceful Diveagar beach destination.",

topPlaces: [
    {
        title: "Diveagar Beach",
        description:
            "Diveagar Beach is a clean and less crowded beach in the Konkan region known for its long shoreline, soft sand, and peaceful environment. It is ideal for relaxation, photography, and long walks along the coast. The calm waves and natural beauty make it one of the most preferred weekend getaway destinations from Pune."
    },
    {
        title: "Suvarna Ganesh Temple",
        description:
            "Suvarna Ganesh Temple in Diveagar is famous for its golden idol of Lord Ganesha, discovered centuries ago. It is a highly spiritual site that attracts devotees seeking blessings and peace in a serene village environment surrounded by coconut trees."
    },
    {
        title: "Diveagar Coconut Groves",
        description:
            "The coconut groves around Diveagar add to its natural Konkan charm, offering scenic views and a refreshing coastal atmosphere. These lush green surroundings make it perfect for nature walks and photography during a peaceful beach vacation."
    },
    {
        title: "Harihareshwar Beach (Nearby)",
        description:
            "Harihareshwar Beach is located close to Diveagar and is known for its temple, cliff walk, and scenic coastline. It is a popular extension destination for travelers exploring the Konkan belt from Pune."
    },
    {
        title: "Shrivardhan Beach",
        description:
            "Shrivardhan Beach is a calm coastal destination near Diveagar with soft sand, gentle waves, and a relaxed atmosphere. It is ideal for peaceful vacations and is part of the beautiful Konkan coastal stretch."
    },
    {
        title: "Velas Turtle Beach",
        description:
            "Velas Beach is known for Olive Ridley turtle conservation and seasonal turtle hatching events. It is an eco-tourism hotspot near Diveagar that attracts nature lovers and wildlife enthusiasts."
    },
    {
        title: "Bankot Fort",
        description:
            "Bankot Fort is a historic Maratha-era fort located near the Savitri River offering scenic sea and river views. It adds historical value and adventure to the Diveagar travel route."
    },
    {
        title: "Bagmandla Ferry Route",
        description:
            "Bagmandla is a coastal ferry point connecting villages across the Savitri River. It offers scenic water crossings and a glimpse of traditional Konkan transportation systems."
    },
    {
        title: "Konkan Coastal Highway",
        description:
            "The Pune to Diveagar route via the Konkan coastal highway is filled with lush greenery, mountain curves, river bridges, and coastal views, making the journey itself a memorable part of the cab experience."
    },
    {
        title: "Shrivardhan–Diveagar Coastal Belt",
        description:
            "The Shrivardhan–Diveagar coastal stretch is known for its untouched beaches, coconut farms, and peaceful villages, offering a perfect blend of nature and relaxation for travelers exploring Konkan."
    }
],



services: [
  {
    name: "Pune to Diveagar Cab",
    description: "Rising Cab Service offers reliable Pune to Diveagar Cab service for a safe, scenic, and comfortable Konkan coastal journey to Diveagar beach. Ideal for families, couples, and groups, our service includes well-maintained AC vehicles, experienced long-route drivers, doorstep pickup from Pune, flexible travel timing, and 24x7 support. Enjoy a smooth highway drive through coastal routes with complete comfort, transparent pricing, and a stress-free travel experience to Diveagar."
  },
  {
    name: "Pune to Diveagar Taxi",
    description: "Book Pune to Diveagar Taxi with Rising Cab Service for a comfortable and hassle-free journey to the serene Diveagar beach destination. We provide clean sanitized vehicles, professional chauffeurs, and safe driving across highways and Konkan routes. Perfect for weekend trips, family holidays, and beach vacations with flexible pickup and drop options."
  },
  {
    name: "Cab from Pune to Diveagar",
    description: "Hire Cab from Pune to Diveagar for convenient door-to-door travel with complete flexibility and comfort. Choose from sedans, SUVs, and Innova Crysta based on your group size. Our experienced drivers ensure safe coastal travel with smooth rides, scenic stops, and complete travel assistance."
  },
  {
    name: "Taxi from Pune to Diveagar",
    description: "Taxi from Pune to Diveagar service ensures punctual pickup, professional driving, and a safe long-distance journey to the Konkan beach destination. Ideal for family vacations and weekend getaways, our taxis offer AC comfort, affordable pricing, and reliable service."
  },
  {
    name: "Pune to Diveagar Cab Service",
    description: "Our Pune to Diveagar Cab Service provides complete travel solutions including pickup, drop, sightseeing flexibility, and return options. We focus on safety, comfort, and affordability with trained drivers, well-maintained vehicles, and 24x7 booking assistance."
  },
  {
    name: "Pune to Diveagar Taxi Fare",
    description: "Get transparent Pune to Diveagar Taxi Fare with clear and affordable pricing based on vehicle type and travel plan. We offer budget-friendly and premium options for sedans, SUVs, and Innova Crysta with no hidden charges."
  },
  {
    name: "Pune to Diveagar One Way Cab",
    description: "Book Pune to Diveagar One Way Cab for economical drop-only travel to the scenic Konkan coast. Ideal for solo travelers, couples, and families, this service includes AC vehicles, professional drivers, and smooth highway travel at affordable rates."
  },
  {
    name: "Pune to Diveagar Round Trip Taxi",
    description: "Pune to Diveagar Round Trip Taxi service is perfect for beach vacations and weekend trips. It includes flexible return scheduling, waiting time, comfortable vehicles, and experienced drivers for a complete travel experience."
  },
  {
    name: "Pune to Diveagar Cab Booking",
    description: "Easy Pune to Diveagar Cab Booking system for instant reservations with multiple vehicle choices including Sedan, SUV, Innova Crysta, and Tempo Traveller. Get quick confirmation, transparent pricing, and 24x7 customer support."
  },
  {
    name: "Cheap Pune to Diveagar Cab",
    description: "Affordable Cheap Pune to Diveagar Cab service for budget travelers who want economical yet safe coastal travel. We provide low-cost fares, clean vehicles, and professional drivers without compromising comfort or safety."
  },
  {
    name: "Best Pune to Diveagar Taxi",
    description: "Choose Best Pune to Diveagar Taxi service for premium travel experience with top-rated drivers, comfortable vehicles, and smooth highway driving through scenic Konkan routes."
  },
  {
    name: "Sedan Pune to Diveagar Cab",
    description: "Sedan Pune to Diveagar Cab service is ideal for solo travelers, couples, and small families seeking budget-friendly and comfortable long-distance travel."
  },
  {
    name: "SUV Pune to Diveagar Taxi",
    description: "Book SUV Pune to Diveagar Taxi for group travel requiring extra space and comfort. Our SUVs are perfect for Konkan routes, offering smooth rides and strong performance."
  },
  {
    name: "Innova Pune to Diveagar Cab",
    description: "Premium Innova Pune to Diveagar Cab service for families and groups seeking luxury, comfort, and spacious seating for long coastal journeys."
  },
  {
    name: "Beach Cab Pune Diveagar",
    description: "Beach Cab Pune Diveagar service is specially designed for tourists visiting Diveagar beach. Enjoy scenic coastal drives, flexible stops, and comfortable AC vehicles."
  },
  {
    name: "Diveagar Cab from Pune",
    description: "Diveagar Cab from Pune service offers direct door-to-door travel to the beach destination with safe driving and flexible travel plans."
  },
  {
    name: "Pune to Diveagar Beach Cab",
    description: "Pune to Diveagar Beach Cab service ensures a smooth and scenic coastal journey with professional drivers and comfortable vehicles for a relaxing beach trip."
  },
  {
    name: "Pune to Diveagar Tourist Cab Service",
    description: "Pune to Diveagar Tourist Cab Service provides complete travel solutions for tourists exploring Konkan beaches and nearby attractions."
  },
  {
    name: "Pune to Diveagar Innova Taxi",
    description: "Pune to Diveagar Innova Taxi service offers premium comfort for families and groups with spacious seating and smooth long-distance travel experience."
  },
  {
    name: "Pune to Diveagar Travel Package",
    description: "Pune to Diveagar Travel Package includes pickup, beach visits, sightseeing, and return journey for a complete hassle-free vacation experience."
  },
  {
    name: "Pune to Diveagar Long Distance Taxi",
    description: "Pune to Diveagar Long Distance Taxi service ensures safe, comfortable, and reliable highway travel with experienced drivers and well-maintained vehicles."
  },
  {
    name: "Pune to Diveagar Door to Door Cab",
    description: "Pune to Diveagar Door to Door Cab service provides convenient pickup and drop from your exact location for a seamless travel experience."
  },
  {
    name: "Pune to Diveagar Holiday Package",
    description: "Pune to Diveagar Holiday Package offers complete travel solutions for weekend and holiday trips with sightseeing and comfortable cab service included."
  },
  {
    name: "Pune to Diveagar Family Tour Cab",
    description: "Pune to Diveagar Family Tour Cab is designed for safe and enjoyable family travel with spacious vehicles and customized travel plans."
  },
  {
    name: "Pune to Diveagar Private Taxi Booking",
    description: "Pune to Diveagar Private Taxi Booking offers fully private travel with flexible timing, dedicated vehicle, and professional driver service."
  },
  {
    name: "Pune to Diveagar Round Trip Taxi Service",
    description: "Pune to Diveagar Round Trip Taxi Service ensures smooth travel with return flexibility, waiting time, and comfortable journey planning."
  },
  {
    name: "Pune to Diveagar Beach Holiday Cab",
    description: "Pune to Diveagar Beach Holiday Cab provides complete coastal travel experience with scenic routes, beach visits, and comfortable rides."
  },
  {
    name: "Pune to Diveagar Weekend Tour Package",
    description: "Pune to Diveagar Weekend Tour Package offers curated short trips ideal for weekend getaways with family and friends."
  },
  {
    name: "Best Pune to Diveagar Taxi Service",
    description: "Best Pune to Diveagar Taxi Service ensures premium comfort, safe driving, and reliable travel for a smooth Konkan trip experience."
  },
  {
    name: "Pune to Diveagar Outstation Taxi Booking",
    description: "Pune to Diveagar Outstation Taxi Booking provides easy reservations for long-distance travel with transparent pricing and multiple vehicle options."
  }
],

tableData: [
  ["Pune to Diveagar Cab", "Pune to Diveagar Taxi"],
  ["Cab from Pune to Diveagar", "Taxi from Pune to Diveagar"],
  ["Pune to Diveagar Cab Service", "Pune to Diveagar Taxi Fare"],
  ["Pune to Diveagar One Way Cab", "Pune to Diveagar Round Trip Taxi"],
  ["Pune to Diveagar Cab Booking", "Cheap Pune to Diveagar Cab"],
  ["Best Pune to Diveagar Taxi", "Sedan Pune to Diveagar Cab"],
  ["SUV Pune to Diveagar Taxi", "Innova Pune to Diveagar Cab"],
  ["Beach Cab Pune Diveagar", "Diveagar Cab from Pune"],
  ["Pune to Diveagar Travel Package", "Pune to Diveagar Holiday Package"],
  ["Pune to Diveagar Door to Door Cab", "Pune to Diveagar Beach Cab"]
],



whychoose: [
    {
        WhyChooseheading: "Comfortable Pune to Diveagar Cab Service",
        WhyChoosedescription: "Rising Cab Service provides reliable Pune to Diveagar cab transportation for families, tourists, couples, beach lovers, and weekend vacation travelers."
    },
    {
        WhyChooseheading: "Perfect for Beach Holidays and Relaxation",
        WhyChoosedescription: "Diveagar is known for its clean beaches, peaceful surroundings, coconut groves, and scenic coastal beauty, making it a favorite Konkan getaway."
    },
    {
        WhyChooseheading: "Ideal for Weekend and Family Trips",
        WhyChoosedescription: "Whether planning a family holiday, beach vacation, honeymoon trip, or short coastal getaway, we offer flexible travel solutions."
    },
    {
        WhyChooseheading: "Wide Range of Comfortable Vehicles",
        WhyChoosedescription: "Choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles according to your travel requirements."
    },
    {
        WhyChooseheading: "Explore Popular Attractions Near Diveagar",
        WhyChoosedescription: "Travelers can visit Diveagar Beach, Suvarna Ganesh Temple, Harihareshwar, Shrivardhan Beach, Konkan villages, and nearby coastal attractions."
    },
    {
        WhyChooseheading: "Doorstep Pickup Across Pune & PCMC",
        WhyChoosedescription: "Pickup services are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and nearby locations."
    },
    {
        WhyChooseheading: "Safe and Scenic Konkan Route Travel",
        WhyChoosedescription: "Our experienced drivers ensure smooth travel through scenic coastal routes while providing a safe and comfortable journey."
    },
    {
        WhyChooseheading: "Suitable for Couples, Families, and Groups",
        WhyChoosedescription: "Rising Cab Service caters to family vacations, group outings, corporate trips, beach holidays, and romantic getaways."
    }
]
};

const faqData = [
    {
        question: "Why is Diveagar a popular destination from Pune?",
        answer: "Diveagar is famous for its beautiful beach, peaceful atmosphere, coastal scenery, and proximity to other popular Konkan destinations."
    },
    {
        question: "Can I book a one-way cab from Pune to Diveagar?",
        answer: "Yes, one-way cab services are available along with round-trip and customized travel packages."
    },
    {
        question: "Which attractions can be visited during a Diveagar trip?",
        answer: "Popular attractions include Diveagar Beach, Suvarna Ganesh Temple, Harihareshwar Temple, Shrivardhan Beach, and nearby Konkan sightseeing locations."
    },
    {
        question: "Which vehicle is suitable for a family trip to Diveagar?",
        answer: "Ertiga and Innova Crysta are among the most preferred vehicles due to their spacious seating and comfortable travel experience."
    },
    {
        question: "Do you provide Tempo Travellers for group tours?",
        answer: "Yes, Tempo Travellers and larger vehicles are available for family groups, corporate outings, and tourist groups."
    },
    {
        question: "Can Diveagar and Harihareshwar be covered in one trip?",
        answer: "Yes, customized itineraries can include Diveagar, Harihareshwar, Shrivardhan, and nearby coastal attractions."
    },
    {
        question: "Are weekend holiday packages available for Diveagar?",
        answer: "Yes, customers can choose weekend tours, overnight stays, and multi-day Konkan travel packages."
    },
    {
        question: "Can beach sightseeing and temple visits be combined?",
        answer: "Yes, travel plans can include both beach tourism and religious sightseeing according to customer preferences."
    },
    {
        question: "Are pickups available from Pune Airport and Railway Station?",
        answer: "Yes, pickups can be arranged from Pune Airport, Railway Station, hotels, offices, and residential locations."
    },
    {
        question: "How can I book a Pune to Diveagar Cab?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Ganesh Patil",
        feedback:
            "Our Diveagar beach vacation was incredibly relaxing. The cab was comfortable, the journey was smooth, and we enjoyed the scenic Konkan route throughout the trip.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Rupali Deshmukh",
        feedback:
            "We planned a family getaway covering Diveagar and Harihareshwar. The travel arrangements were excellent, and the entire experience was comfortable and memorable.",
        rating: 5
    }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];














const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Diveagar Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-diveagar-cab.jpg",
"description": "Book Pune to Diveagar Cab Service with Rising Cab Service for safe and comfortable beach travel. Enjoy reliable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars for family trips and weekend getaways.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-diveagar-cab"
}
};





    return (
        <div>

<Helmet>
  <title>Pune to Diveagar Cab Service | Beach Taxi Booking | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Diveagar Cab Service for safe and comfortable beach travel. Get affordable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars for family and weekend trips."
/>

<meta
 name="keywords"
 content="pune to diveagar cab, pune to diveagar taxi, cab from pune to diveagar, taxi from pune to diveagar, pune to diveagar cab service, pune to diveagar taxi fare, pune to diveagar one way cab, pune to diveagar round trip taxi, pune to diveagar cab booking, cheap pune to diveagar cab, best pune to diveagar taxi, sedan pune to diveagar cab, suv pune to diveagar cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>

            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/107.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetodivegarcab;